import { getNameFromSignatureProperties } from "../../../utils";
export const getSignatureIdentity = (signature, certificates) => {
    var _a;
    const [, signatoryCertificateId] = (_a = signature.signature.cert_chain.find(([, childId]) => certificates[childId].signatory)) !== null && _a !== void 0 ? _a : ["", ""];
    if (!signatoryCertificateId)
        return "";
    return getNameFromSignatureProperties(certificates[signatoryCertificateId].subject);
};
export const convertToShortValidationResult = (result) => {
    if (result === "Invalid certificate" ||
        result === "Malformed certificate container") {
        return "Invalid";
    }
    else if (result === "Blacklisted certificate") {
        return "Blacklisted";
    }
    else if (result === "Impersonation attempt") {
        return "Impersonation";
    }
    else if (result === "Revoked certificate" ||
        result === "Signed with revoked certificate after revocation" ||
        result.startsWith("Certificate revocation reason:")) {
        return "Revoked";
    }
    else if (result === "Self-signed certificate") {
        return "Self-signed";
    }
    else if (result === "Expired certificate" ||
        result === "Certificate signed after expiration" ||
        result === "Certificate signed before valid start time") {
        return "Expired";
    }
    else if (result === "Untrusted certificate") {
        return "Untrusted";
    }
    else if (result === "Whitelisted certificate") {
        return "Whitelisted";
    }
    else {
        return "Valid";
    }
};
//# sourceMappingURL=utils.js.map